import { BrowserSupport } from '@tableau/browser-support';
import { SigningInSpinner } from '~src/app/spaces/Login/SigningInSpinner';
import { SignInLogo } from '~src/app/spaces/Login/SignInLogo';
import { SignInNoteDescription } from '~src/app/spaces/Login/SignInNoteDescription';
import { LicenseExpirationWarning } from './LicenseExpirationWarning';
import { PreLoginMessage } from './PreLoginMessage';
import React = require('react');


export const LoginPage: React.FunctionComponent = props => {

  return <div className={'tb-login' + (BrowserSupport.IsTouch() ? ' tb-login-mobile' : '')}>
    <span className={'tb-login-form-container' + (BrowserSupport.IsTouch() ? ' tb-login-form-container-mobile' : '')} role='main'>
      <div>
        <SignInLogo />
      </div>
      {props.children}
    </span>
    <LicenseExpirationWarning />
    <PreLoginMessage />
    <SignInNoteDescription />
  </div>;
};
